export default "__VITE_ASSET__DzNw_Apj__"